import React from "react";

const SpecialCampaignSkeleton = () => {
  return (
    <div className="w-full bg-gray-50 px-3 sm:px-6 md:px-10 py-6 md:py-10">
      <div className="relative border border-gray-200 shadow-xl rounded-xl p-4 sm:p-6 md:p-10 bg-white animate-pulse">
        <div className="flex flex-col md:flex-row gap-4 md:gap-10">
          {/* Image Skeleton */}
          <div className="w-full md:w-1/2 h-56 sm:h-64 md:h-80 bg-gray-300 rounded-xl" />

          {/* Content Skeleton */}
          <div className="w-full md:w-1/2 flex flex-col justify-between">
            {/* Title */}
            <div className="h-6 sm:h-7 md:h-8 bg-gray-300 rounded w-3/4 mb-3" />

            {/* Description */}
            <div className="space-y-2 flex-grow">
              <div className="h-4 bg-gray-300 rounded w-full" />
              <div className="h-4 bg-gray-300 rounded w-11/12" />
              <div className="h-4 bg-gray-300 rounded w-10/12" />
              <div className="h-4 bg-gray-300 rounded w-9/12" />
            </div>

            {/* Button */}
            <div className="mt-6">
              <div className="h-10 w-32 bg-gray-300 rounded-lg" />
            </div>
          </div>
        </div>

        {/* Left Arrow */}
        <div className="absolute top-1/2 left-2 -translate-y-1/2 h-8 w-8 bg-gray-300 rounded-full" />

        {/* Right Arrow */}
        <div className="absolute top-1/2 right-2 -translate-y-1/2 h-8 w-8 bg-gray-300 rounded-full" />
      </div>
    </div>
  );
};

export default SpecialCampaignSkeleton;
